const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');

/**
 * YM-BDGPS 按键传感器模块
 * 
 * @readonly
 */
const DEVICE_OPT = {
    type: 'sensor'
};

/**
 * Manage communication with a YM-BDGPS peripheral over a Scratch Link client socket.
 */
class YMUSPeripheral extends SensorPeripheral {
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DEVICE_OPT);
    }
}

class ScratchYMBDGPSDevice {

    get DEVICE_ID() {
        return 'YMUS';
    }

    constructor(runtime, originalDeviceId) {
        this.runtime = runtime;
        this._peripheral = new YMUSPeripheral(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
        
        // this._setupNotifyHandlers();
         //  添加：是否正在连接或已连接
         this._connectionLock = false;
         this._connectionPromise = null;
    }

    getInfo() {
        return [{
            id: 'YMUS',
            name: formatMessage({
                id: 'YMUS.categoryName',
                default: 'YM US',
                description: 'Label for the YM US extension category'
            }),
            color1: "#00CCFF",
            color2: "#6DB14D",
            color3: "#64A23C",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMUS.ble.connect',
                        default: 'connect to YM-US-[DEVICE_NAME]',
                        description: 'Connect to YM US'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMUS.ble.disconnect',
                        default: 'disconnect from YM US',
                        description: 'Disconnect from YM US'
                    })
                },
                {
                    opcode: 'getDistance',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMUS.getDistance',
                        default: 'get distance',
                        description: 'Get the distance by gps'
                    })
                },
            ],
            menus: {}
        }];
    }

/**
     * Connect to YM-BDGPS device
     * @param {object} args - { DEVICE_NAME }
     */
async connect(args) {
    const deviceName = 'YM-US-' + (args.DEVICE_NAME?.trim() || "");

    // 🔒 如果已经在连接流程中，直接返回已有 promise
    if (this._connectionPromise) {
        console.log(`Connection already in progress or completed. Skipping duplicate connect for ${deviceName}`);
        return await this._connectionPromise;
    }

    // 🔒 创建一个连接 promise 并缓存，防止后续调用再次触发 requestDevice
    this._connectionPromise = this._doConnect(deviceName).catch(err => {
        console.error('Connection failed:', err);
        // 失败后允许重试（可选）：若想禁止重试，则不清理 _connectionPromise
        // this._connectionPromise = null;
    });

    return await this._connectionPromise;
}
 /**
     * 实际执行连接逻辑（仅执行一次）
     */
 async _doConnect(deviceName) {
    // 再次检查是否已连接（避免 race condition）
    const connected = await this.isConnected();
    if (connected) {
        console.log('Already connected. Skip connection.');
        return true;
    }

    console.log(`Connecting to YM US device: ${deviceName}`);

    try {
        // ✅ 此处调用 bleUtils.connect，假设它封装了 requestDevice
        await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
        console.log(`Connected to device: ${deviceName}`);
        //await this._setupNotifyHandlers();
        return true;
    } catch (error) {
        // 清理状态，允许用户手动重试
        this._connectionPromise = null;
        throw error; // 抛出错误以便上层处理
    }
}
    async isConnected() {
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
                 // 🔒 断开后释放连接锁，允许重新连接
                 this._connectionPromise = null;
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    

    async getDistance() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.distance);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    const hexStr = buffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const brightness = parseInt(hexStr, 16);
                    console.log(`distance: ${brightness}`);
                    
                    return brightness;
                }
            } catch (error) {
                console.error('Failed to set distance:', error);
            }
        }
    }
}

module.exports = ScratchYMBDGPSDevice;
